import { UPDATE_CORRECT_OTP } from '../constants/actionTypes'

export default (state = false, action) => {
    switch (action.type) {
        case UPDATE_CORRECT_OTP:
            return action.payload
        default:
            return state
    }
}
